/* @flow */
import { Random } from '../../javascripts/utils/Random';
import { ageGroup, gender, type AgeGroup, type Gender } from './types';

export const genderGen: Random<Gender> = Random.of(gender.MALE, gender.FEMALE);
export const ageGroupGen: Random<AgeGroup> = Random.of(ageGroup.ADULT, ageGroup.CHILD, ageGroup.MIDDLE_AGE);
export const customerKindGen: Random<1 | 2 | 3> = Random.of(1, 2, 3);
